import { render, staticRenderFns } from "./StandalonePreview.vue?vue&type=template&id=f168d3de&scoped=true&"
import script from "./StandalonePreview.vue?vue&type=script&lang=ts&"
export * from "./StandalonePreview.vue?vue&type=script&lang=ts&"
import style0 from "./StandalonePreview.vue?vue&type=style&index=0&id=f168d3de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f168d3de",
  null
  
)

export default component.exports